import { takeLatest } from 'redux-saga/effects';
import DeleteMachineConstants from '~/domain/asset-details-common/components/DeleteMachine/constants';
import MachineAPI from '~/api/machine-api';
import callRequestSaga from '~/sagas/utils/request-saga';

export function* deleteMachine({ machineId, removeMachineFromList }) {
  yield* callRequestSaga(
    MachineAPI.deleteMachine,
    {
      request: DeleteMachineConstants.DELETE_MACHINE_REQUEST,
      success: DeleteMachineConstants.DELETE_MACHINE_REQUEST_SUCCESS,
      failure: DeleteMachineConstants.DELETE_MACHINE_REQUEST_ERROR,
      payload: {
        machineId,
        removeMachineFromList,
      },
    },
    machineId
  );
}

export function* deleteMachineSaga() {
  // @ts-ignore
  yield takeLatest(DeleteMachineConstants.DELETE_MACHINE, deleteMachine);
}

export default [deleteMachineSaga];
